import React, { Fragment, useEffect, useState, useRef } from "react";
import { Form, Input, Select, Button } from "antd";
import belgeTuruLists from '../../services/belgeTuruLists';
import history from "../../history";
import queryString from 'query-string';
import basvuruAnaDurumTurleriList from "../../services/basvuruAnaDurumTurleriList";
import mahalleList from "../../services/mahalleList";
import ilceList from "../../services/ilceList";
const { Option } = Select;


const parsed = queryString.parse(history.location.search);

const BasvuruAnaOzetFilterRow = (props) => {
    const [belgeTurus, setBelgeTurus] = useState([]);
    const [basvuruAnaDurumTurleris, setBasvuruAnaDurumTurleris] = useState([]);
    const [ilces, setIlces] = useState([]);
    const [mahalles, setMahalles] = useState([]);
    const [adaParsels, setAdaParsels] = useState([]);


    const [form] = Form.useForm();

    const belgeGrubuId = parsed.belgeGrubuId.split(',').map(item => { return parseInt(item) });

    useEffect(() => {
        belgeTuruLists(belgeGrubuId).then(res => { setBelgeTurus(res.data.result) });
        basvuruAnaDurumTurleriList().then(res => { setBasvuruAnaDurumTurleris(res.data.result) });
        ilceList().then(res => { setIlces(res.data.result) });
        mahalleList().then(res => { setMahalles(res.data.result) });
    }, []);

    const onFinish = (values) => {
        props.onSubmit(values.belgeTuruRef, values.basvuruAnaDurumTurleriRef, values.basvuruAnaObjectIdRef, values.ilceRef, values.mahalleRef, values.adaParselRef);
    }


    return <Form layout="inline" style={{ marginLeft: 10, justifyContent: "space-between", rowGap: 10 }} onFinish={onFinish} >
        {/* <Form.Item  name="parentObjectid" label="Başvuru Ana No"
            {...formItemLayout}
            >
                        <Input placeholder="" />
            </Form.Item> */}
        <Form.Item
            name="basvuruAnaObjectIdRef" key="basvuruAnaObjectId"
        //   label ="Başvuru Ana No"
        >
            <Input type='number' placeholder="Başvuru Ana No" />
        </Form.Item>
        <Form.Item name="belgeTuruRef" key="belgeTuruId"
            rules={[{ required: false, message: 'Lütfen Belge Türü Seçiniz!' }]} >
            <Select
                showSearch
                allowClear
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Belge Türü"
                style={{ width: 200 }}
            // onChange={onBelgeTuruChange}
            >
                {belgeTurus && belgeTurus.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
            </Select>
        </Form.Item>
        <Form.Item name="basvuruAnaDurumTurleriRef" key="basvuruAnaDurumId"
            rules={[{ required: false, message: 'Lütfen Durum Türü Seçiniz!' }]} >
            <Select
                showSearch
                allowClear
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Başvuru Durumu"
                style={{ width: 200 }}
            >
                {basvuruAnaDurumTurleris && basvuruAnaDurumTurleris.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
            </Select>
        </Form.Item>
        {props.getIsCompanyIlOzelIdare() && <Form.Item name="ilceRef" key="ilceId"
            rules={[{ required: false, message: 'Lütfen İlçe Seçiniz!' }]} >
            <Select
                showSearch
                allowClear
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="İlçe"
                style={{ width: 200 }}
            >
                {ilces && ilces.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
            </Select>
        </Form.Item>
        }
        <Form.Item name="mahalleRef" key="mahalleId"
            rules={[{ required: false, message: 'Lütfen Mahalle Seçiniz!' }]} >
            <Select
                showSearch
                allowClear
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Mahalle"
                style={{ width: 200 }}
            >
                {mahalles && mahalles.map(bt => <Option key={bt.objectid} value={bt.objectid}>{bt.adi}</Option>)}
            </Select>
        </Form.Item>
        <Form.Item name="adaParselRef" key="adaParsel">
            <Input placeholder="Ada/Parsel" >
            </Input>
        </Form.Item>
        <Form.Item key="submitButton">
            <Button type="primary" htmlType="submit" style={{ marginBottom: 20, marginLeft: 10 }} onClick={() => { }}>
                <span style={{ fontWeight: "bold" }}>Sorgula</span>
            </Button>
        </Form.Item>
    </Form>
}

export default BasvuruAnaOzetFilterRow;

